import React from 'react';
import PropTypes from 'prop-types';
import { Input, Form, Dropdown } from 'semantic-ui-react';

const countries = [
  { key: '0', value: '', text: ' ' },
  { key: 'US', value: 'US', text: 'US' },
  { key: 'CC', value: 'CC', text: 'CANADA' },
  { key: 'MX', value: 'MX', text: 'MEXICO' },
  { key: 'AC', value: 'AC', text: 'AFGHANISTAN' },
  { key: 'AD', value: 'AD', text: 'ALBANIA' },
  { key: 'AF', value: 'AF', text: 'ALGERIA' },
  { key: 'AG', value: 'AG', text: 'ANDORRA' },
  { key: 'AH', value: 'AH', text: 'ANGOLA' },
  { key: 'AI', value: 'AI', text: 'ANGUILLA' },
  { key: 'AJ', value: 'AJ', text: 'ANTIGUA &amp; BARBUDA' },
  { key: 'AM', value: 'AM', text: 'ARGENTINA' },
  { key: 'AN', value: 'AN', text: 'ARMENIA' },
  { key: 'AO', value: 'AO', text: 'ARUBA' },
  { key: 'AQ', value: 'AQ', text: 'ASCENSION' },
  { key: 'AT', value: 'AT', text: 'AUSTRALIA' },
  { key: 'AU', value: 'AU', text: 'AUSTRIA' },
  { key: 'AV', value: 'AV', text: 'AZERBAIJAN' },
  { key: 'AW', value: 'AW', text: 'AZORES' },
  { key: 'BA', value: 'BA', text: 'BAHAMAS' },
  { key: 'BB', value: 'BB', text: 'BAHRAIN' },
  { key: 'BD', value: 'BD', text: 'BALARUS' },
  { key: 'BE', value: 'BE', text: 'BANGLADESH' },
  { key: 'BF', value: 'BF', text: 'BARBADOS' },
  { key: 'BG', value: 'BG', text: 'BELGIUM' },
  { key: 'BH', value: 'BH', text: 'BELIZE' },
  { key: 'BI', value: 'BI', text: 'BENIN' },
  { key: 'BJ', value: 'BJ', text: 'BERMUDA' },
  { key: 'BK', value: 'BK', text: 'BHUTAN' },
  { key: 'BL', value: 'BL', text: 'BOLIVIA' },
  { key: 'BM', value: 'BM', text: 'BOSNIA-HERCEGOVINA' },
  { key: 'BN', value: 'BN', text: 'BOTSWANA' },
  { key: 'BO', value: 'BO', text: 'BRAZIL' },
  { key: 'BP', value: 'BP', text: 'BRITISH VIRGIN ISLANDS' },
  { key: 'BQ', value: 'BQ', text: 'BRUNEI' },
  { key: 'BR', value: 'BR', text: 'BULGARIA' },
  { key: 'BS', value: 'BS', text: 'BURKINA' },
  { key: 'BT', value: 'BT', text: 'BURUNDI' },
  { key: 'CB', value: 'CB', text: 'CAMEROON' },
  { key: 'CD', value: 'CD', text: 'CAPE VERDE' },
  { key: 'CE', value: 'CE', text: 'CAYMAN ISLANDS' },
  { key: 'CF', value: 'CF', text: 'CENTRAL AFRICAN REPUBLIC' },
  { key: 'CG', value: 'CG', text: 'CHAD' },
  { key: 'CH', value: 'CH', text: 'CHILE' },
  { key: 'CI', value: 'CI', text: 'CHINA, PEOPLES REP. OF CHINA' },
  { key: 'CJ', value: 'CJ', text: 'COLOMBIA' },
  { key: 'CK', value: 'CK', text: 'COMOROS' },
  { key: 'CL', value: 'CL', text: 'CONGO' },
  { key: 'CM', value: 'CM', text: 'COOK ISLANDS' },
  { key: 'CN', value: 'CN', text: 'CORSICA' },
  { key: 'CP', value: 'CP', text: 'COSTA RICA' },
  { key: 'CQ', value: 'CQ', text: 'COTE D\'IVORIE' },
  { key: 'CR', value: 'CR', text: 'CROATIA' },
  { key: 'CS', value: 'CS', text: 'CUBA' },
  { key: 'CU', value: 'CU', text: 'CYPRUS' },
  { key: 'CV', value: 'CV', text: 'CZECH REPUBLIC' },
  { key: 'CA', value: 'DA', text: 'DENMARK' },
  { key: 'DB', value: 'DB', text: 'DJIBOUTI' },
  { key: 'DD', value: 'DD', text: 'DOMINICA' },
  { key: 'DF', value: 'DF', text: 'DOMINICAN REPUBLIC' },
  { key: 'EA', value: 'EA', text: 'EAST TIMOR' },
  { key: 'EB', value: 'EB', text: 'EASTER ISLAND' },
  { key: 'EC', value: 'EC', text: 'ECUADOR' },
  { key: 'ED', value: 'ED', text: 'EGYPT' },
  { key: 'EE', value: 'EE', text: 'EL SALVADOR' },
  { key: 'EF', value: 'EF', text: 'ENGLAND' },
  { key: 'EG', value: 'EG', text: 'EQUATORIAL GUINEA' },
  { key: 'EH', value: 'EH', text: 'ERITREA' },
  { key: 'EI', value: 'EI', text: 'ESTONIA' },
  { key: 'EJ', value: 'EJ', text: 'ETHIOPIA' },
  { key: 'FA', value: 'FA', text: 'FALKLAND ISLANDS' },
  { key: 'FB', value: 'FB', text: 'FAROE ISLANDS' },
  { key: 'FC', value: 'FC', text: 'FIJI' },
  { key: 'FD', value: 'FD', text: 'FINLAND' },
  { key: 'FE', value: 'FE', text: 'FRANCE' },
  { key: 'FF', value: 'FF', text: 'FRENCH GUIANA' },
  { key: 'FG', value: 'FG', text: 'FRENCH POLYNESIA' },
  { key: 'GB', value: 'GB', text: 'GABON' },
  { key: 'GC', value: 'GC', text: 'GAMBIA' },
  { key: 'GD', value: 'GD', text: 'GEORGIA, REPUBLIC OF' },
  { key: 'GE', value: 'GE', text: 'GERMANY' },
  { key: 'GF', value: 'GF', text: 'GHANA' },
  { key: 'GG', value: 'GG', text: 'GIBRALTAR' },
  { key: 'GH', value: 'GH', text: 'GREAT BRITAIN' },
  { key: 'GI', value: 'GI', text: 'GREECE' },
  { key: 'GJ', value: 'GJ', text: 'GREENLAND' },
  { key: 'GK', value: 'GK', text: 'GRENADA' },
  { key: 'GL', value: 'GL', text: 'GUADELOUPE' },
  { key: 'GM', value: 'GM', text: 'GUATEMALA' },
  { key: 'GN', value: 'GN', text: 'GUINEA' },
  { key: 'GO', value: 'GO', text: 'GUINEA-BISSAU' },
  { key: 'GP', value: 'GP', text: 'GUYANA' },
  { key: 'HA', value: 'HA', text: 'HAITI' },
  { key: 'HB', value: 'HB', text: 'HONDURAS' },
  { key: 'HC', value: 'HC', text: 'HONG KONG' },
  { key: 'HD', value: 'HD', text: 'HUNGARY' },
  { key: 'IB', value: 'IB', text: 'ICELAND' },
  { key: 'IC', value: 'IC', text: 'INDIA' },
  { key: 'IE', value: 'IE', text: 'INDONESIA' },
  { key: 'IF', value: 'IF', text: 'IRAN' },
  { key: 'IG', value: 'IG', text: 'IRAQ' },
  { key: 'IH', value: 'IH', text: 'IRELAND' },
  { key: 'II', value: 'II', text: 'ISRAEL' },
  { key: 'IJ', value: 'IJ', text: 'ITALY' },
  { key: 'JA', value: 'JA', text: 'JAMAICA' },
  { key: 'JB', value: 'JB', text: 'JAPAN' },
  { key: 'JC', value: 'JC', text: 'JORDAN' },
  { key: 'KA', value: 'KA', text: 'KAMPUCHEA (CAMBODIA)' },
  { key: 'KB', value: 'KB', text: 'KAZAKSTAN' },
  { key: 'KC', value: 'KC', text: 'KENYA' },
  { key: 'KD', value: 'KD', text: 'KIRIBATI' },
  { key: 'KE', value: 'KE', text: 'KOREA, PEOPLES REP. OF (NORTH)' },
  { key: 'KF', value: 'KF', text: 'KOREA, REPUBLIC OF (SOUTH)' },
  { key: 'KG', value: 'KG', text: 'KUWAIT' },
  { key: 'KH', value: 'KH', text: 'KYRGYZSTAN' },
  { key: 'LB', value: 'LB', text: 'LAOS' },
  { key: 'LC', value: 'LC', text: 'LATVIA' },
  { key: 'LD', value: 'LD', text: 'LEBANON' },
  { key: 'LE', value: 'LE', text: 'LESOTHO' },
  { key: 'LF', value: 'LF', text: 'LIBERIA' },
  { key: 'LG', value: 'LG', text: 'LIBYA' },
  { key: 'LH', value: 'LH', text: 'LIECHTENSTEIN' },
  { key: 'LI', value: 'LI', text: 'LITHUANIA' },
  { key: 'LJ', value: 'LJ', text: 'LUXEMBOURG' },
  { key: 'MC', value: 'MC', text: 'MACAU' },
  { key: 'MF', value: 'MF', text: 'MACEDONIA' },
  { key: 'MG', value: 'MG', text: 'MADAGASCAR' },
  { key: 'MJ', value: 'MJ', text: 'MADEIRA ISLANDS' },
  { key: 'MK', value: 'MK', text: 'MALAWI' },
  { key: 'ML', value: 'ML', text: 'MALAYSIA' },
  { key: 'MM', value: 'MM', text: 'MALDIVES' },
  { key: 'MQ', value: 'MQ', text: 'MALI' },
  { key: 'MR', value: 'MR', text: 'MALTA' },
  { key: 'MU', value: 'MU', text: 'MARTINIQUE' },
  { key: 'MV', value: 'MV', text: 'MAURITANIA' },
  { key: 'MW', value: 'MW', text: 'MAURITIUS' },
  { key: 'MY', value: 'MY', text: 'MOLDOVA' },
  { key: 'MZ', value: 'MZ', text: 'MONACO' },
  { key: 'M2', value: 'M2', text: 'MONGOLIA' },
  { key: 'M3', value: 'M3', text: 'MONTENEGRO' },
  { key: 'M4', value: 'M4', text: 'MONTSERRAT' },
  { key: 'M5', value: 'M5', text: 'MOROCCO' },
  { key: 'M6', value: 'M6', text: 'MOZAMBIQUE' },
  { key: 'M7', value: 'M7', text: 'MYANMAR (BURMA)' },
  { key: 'NA', value: 'NA', text: 'NAMIBIA' },
  { key: 'NG', value: 'NG', text: 'NAURU' },
  { key: 'NI', value: 'NI', text: 'NEPAL' },
  { key: 'NK', value: 'NK', text: 'NETHERLANDS' },
  { key: 'NL', value: 'NL', text: 'NETHERLANDS ANTILLES' },
  { key: 'NN', value: 'NN', text: 'NEW CALEDONIA' },
  { key: 'NO', value: 'NO', text: 'NEW ZEALAND' },
  { key: 'NP', value: 'NP', text: 'NICARAGUA' },
  { key: 'NQ', value: 'NQ', text: 'NIGER' },
  { key: 'NR', value: 'NR', text: 'NIGERIA' },
  { key: 'NX', value: 'NX', text: 'NORTHERN IRELAND' },
  { key: 'NW', value: 'NW', text: 'NORWAY' },
  { key: 'OA', value: 'OA', text: 'OMAN' },
  { key: 'PB', value: 'PB', text: 'PAKISTAN' },
  { key: 'PC', value: 'PC', text: 'PANAMA' },
  { key: 'PD', value: 'PD', text: 'PAPUA NEW GUINEA' },
  { key: 'PF', value: 'PF', text: 'PARAGUAY' },
  { key: 'PG', value: 'PG', text: 'PERU' },
  { key: 'PH', value: 'PH', text: 'PHILIPPINES' },
  { key: 'PI', value: 'PI', text: 'PITCAIRN ISLANDS' },
  { key: 'PJ', value: 'PJ', text: 'POLAND' },
  { key: 'PK', value: 'PK', text: 'PORTUGAL' },
  { key: 'QA', value: 'QA', text: 'QATAR' },
  { key: 'RA', value: 'RA', text: 'REUNION' },
  { key: 'RB', value: 'RB', text: 'ROMANIA' },
  { key: 'RC', value: 'RC', text: 'RUSSIA' },
  { key: 'RD', value: 'RD', text: 'RWANDA' },
  { key: 'SA', value: 'SA', text: 'SAN MARINO' },
  { key: 'SB', value: 'SB', text: 'SAO TOME &amp; PRINCIPE' },
  { key: 'SE', value: 'SE', text: 'SAUDI ARABIA' },
  { key: 'SF', value: 'SF', text: 'SCOTLAND' },
  { key: 'SG', value: 'SG', text: 'SENEGAL' },
  { key: 'SH', value: 'SH', text: 'SERBIA' },
  { key: 'SI', value: 'SI', text: 'SEYCHELLES' },
  { key: 'SJ', value: 'SJ', text: 'SIERRA LEONE' },
  { key: 'SL', value: 'SL', text: 'SINGAPORE' },
  { key: 'SM', value: 'SM', text: 'SLOVAKIA' },
  { key: 'SN', value: 'SN', text: 'SLOVENIA' },
  { key: 'SO', value: 'SO', text: 'SOLOMON ISLANDS' },
  { key: 'SP', value: 'SP', text: 'SOMALIA' },
  { key: 'SQ', value: 'SQ', text: 'SOUTH AFRICA' },
  { key: 'SR', value: 'SR', text: 'SPAIN' },
  { key: 'SS', value: 'SS', text: 'ST HELENA' },
  { key: 'ST', value: 'ST', text: 'ST KITTS &amp; NEVIS' },
  { key: 'SU', value: 'SU', text: 'ST LUCIA' },
  { key: 'SV', value: 'SV', text: 'ST PIERRE &amp; MIQUELON' },
  { key: 'SW', value: 'SW', text: 'ST VINCENT &amp; THE GRENADINES' },
  { key: 'SX', value: 'SX', text: 'SRI LANKA' },
  { key: 'SY', value: 'SY', text: 'SUDAN' },
  { key: 'SZ', value: 'SZ', text: 'SURINAME' },
  { key: 'S2', value: 'S2', text: 'SWAZILAND' },
  { key: 'S3', value: 'S3', text: 'SWEDEN' },
  { key: 'S4', value: 'S4', text: 'SWITZERLAND' },
  { key: 'S5', value: 'S5', text: 'SYRIA' },
  { key: 'S6', value: 'S6', text: 'ST EUSTATIUS' },
  { key: 'TA', value: 'TA', text: 'TAIWAN, REP. OF CHINA' },
  { key: 'TB', value: 'TB', text: 'TAJIKISTAN' },
  { key: 'TC', value: 'TC', text: 'TANZANIA' },
  { key: 'TD', value: 'TD', text: 'THAILAND' },
  { key: 'TE', value: 'TE', text: 'TOGO' },
  { key: 'TF', value: 'TF', text: 'TONGA' },
  { key: 'TG', value: 'TG', text: 'TRINIDAD &amp; TOBAGO' },
  { key: 'TH', value: 'TH', text: 'TRISTAN DA CUNHA' },
  { key: 'TI', value: 'TI', text: 'TUNISIA' },
  { key: 'TJ', value: 'TJ', text: 'TURKEY' },
  { key: 'TK', value: 'TK', text: 'TURKMENISTAN' },
  { key: 'TL', value: 'TL', text: 'TURKS &amp; CAICOS ISLANDS' },
  { key: 'TM', value: 'TM', text: 'TUVALU' },
  { key: 'UA', value: 'UA', text: 'UGANDA' },
  { key: 'UB', value: 'UB', text: 'UKRAINE' },
  { key: 'UC', value: 'UC', text: 'UNITED ARAB EMIRATES' },
  { key: 'UD', value: 'UD', text: 'URUGUAY' },
  { key: 'UE', value: 'UE', text: 'UZBEKISTAN' },
  { key: 'VB', value: 'VB', text: 'VANUATU' },
  { key: 'VC', value: 'VC', text: 'VATICAN CITY' },
  { key: 'VD', value: 'VD', text: 'VENEZUELA' },
  { key: 'VE', value: 'VE', text: 'VIETNAM' },
  { key: 'WB', value: 'WB', text: 'WALES' },
  { key: 'WC', value: 'WC', text: 'WALLIS &amp; FUTUNA ISLANDS' },
  { key: 'WD', value: 'WD', text: 'WESTERN SAMOA' },
  { key: 'YA', value: 'YA', text: 'YEMEN' },
  { key: 'ZA', value: 'ZA', text: 'ZAIRE' },
  { key: 'ZB', value: 'ZB', text: 'ZAMBIA' },
  { key: 'ZC', value: 'ZC', text: 'ZIMBABWE' },
  { key: 'ZS', value: 'ZS', text: 'YUGOSLAVIA' },
];

const getCountry = (countryCode) => {
  const cc = !countryCode || countryCode === '' ? 'US' : countryCode;
  const country = countries.find(each => each.value === cc);
  return !country ? '' : country.text;
};

const CountrySelector = props => (
  props.readOnly !== true ?
    <Form.Field
      control={Dropdown}
      label="Country"
      placeholder="Please select a country"
      value={props.member.country}
      onChange={props.fieldChangeHandler}
      name="country"
      options={countries}
      required={props.required === true}
      width="5"
      search
      selection
    />
    :
    <Form.Field
      control={Input}
      label="Country"
      value={getCountry(props.member.country)}
      name="country"
      required={props.required === true}
      width={props.width ? props.width : '16'}
      readOnly
    />
);

CountrySelector.propTypes = {
  fieldChangeHandler: PropTypes.func,
  member: PropTypes.object,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  width: PropTypes.string,
};

export default CountrySelector;



// WEBPACK FOOTER //
// ./src/app/components/Countries/index.js